import usePostToBackend from "../../shared/lib/post-to-backend";

export default function useCreateWorkflow() {
  const { mutate } = usePostToBackend({
    path: "/workflows",
  });

  return { mutate };
}
